import { useMemo } from "react";
import type { ReportAccessType } from "@entrilia/shared/api/reportAccessTypes";
import type { GroupBasedAuthorization, GroupForSharing } from "../../../../../../../../../api/types/svTypes";
import AuthorizedGroupsList from "./AuthorizedGroupsList.tsx";
import { buildAuthorizedGroupItems } from "./authorizedItems.ts";

interface AuthorizedGroupsProps {
  authorizedGroups: GroupBasedAuthorization[];
  allGroups: GroupForSharing[];
  disabled: boolean;
  onAccessChanged: (groupId: string, access: ReportAccessType) => void;
  onRemoveGroup: (groupId: string) => void;
}

export default function AuthorizedGroups({
  authorizedGroups,
  allGroups,
  disabled,
  onAccessChanged,
  onRemoveGroup,
}: AuthorizedGroupsProps) {
  const items = useMemo(() => buildAuthorizedGroupItems(authorizedGroups, allGroups), [authorizedGroups, allGroups]);

  if (items.length === 0) {
    return null;
  }

  return (
    <AuthorizedGroupsList
      items={items}
      disabled={disabled}
      onAccessChanged={onAccessChanged}
      onRemoveGroup={onRemoveGroup}
    />
  );
}
